export default {
  EDUCATOR_URL: process.env.NEXT_PUBLIC_EDUCATOR_URL,
};
